module.exports = __webpack_public_path__ + "img/Chevron-Down_16px_Icon_Disabled-Light.4afd0e25.svg";